var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cover-layer invisible",style:({'position': _vm.dom ? 'absolute' : 'fixed'})}),_c('div',{staticClass:"c-loading flex-center an an-fadein",class:{'an-fadeout': _vm.end},style:({'position': _vm.dom ? 'absolute' : 'fixed'})},[_c('i',{staticClass:"tf tf-loading tf-spin"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }